import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';

@Component({
  selector: 'zest-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public state: string = undefined;
  public toHome = false;
  public showCustomErrorMessage = false;
  public customErrorMessage = '';

  constructor(private headerService: HeaderService, private footerService: FooterService, private loaderService: LoaderService, private awsTrackingService: AwsTrackingService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.headerService.ShowHeaderSource.next(new Header(2, false, 0, false, '', false));
    this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    this.route.queryParams.subscribe(value => {
      if (value.state) {
        this.state = value.state;
        this.awsTrackingService.gtmTriggerEvent(this.state + '-Error');
        if (this.state === 'expired_loan_agreement') {
          this.showCustomErrorMessage = true;
          this.customErrorMessage = 'The loan agreement link has expired.';
        } else if (this.state === 'failed_loan_agreement') {
          this.showCustomErrorMessage = true;
          this.customErrorMessage = 'Loan agreement generation is in progress. Please close the window and click the link after some time.';
        } else {
          this.showCustomErrorMessage = false;
          this.customErrorMessage = '';
        }
      }
    });
    if (!this.state) {
      this.awsTrackingService.gtmTriggerEvent('404-Error');
    }
  }
  goToHome() {
    this.toHome = true;
    window.open('http://www.zestmoney.in', '_self');
  }

}
